import { render, staticRenderFns } from "./defaultModal.vue?vue&type=template&id=12e4cf7e&"
import script from "./defaultModal.vue?vue&type=script&lang=js&"
export * from "./defaultModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports